import { render, staticRenderFns } from "./define.vue?vue&type=template&id=a004bda2&"
import script from "./define.vue?vue&type=script&lang=js&"
export * from "./define.vue?vue&type=script&lang=js&"
import style0 from "./define.vue?vue&type=style&index=0&id=a004bda2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports